export interface DemoCompanyBrand {
  slug: string;
  name: string;
  tagline: string;
  loginMessage: string;
  logoUrl: string;
  logoUrlDark?: string;
  primaryColor: string; // HSL values
  primaryColorHex: string;
  accentColor: string;
  supportEmail: string;
  sampleStats: {
    activeUsers: number;
    simulationsCompleted: number;
    avgScore: number;
    teamMembers: number;
  };
  sampleSimulations: Array<{
    name: string;
    type: string;
    difficulty: string;
    duration: string;
  }>;
}

export const demoCompanies: Record<string, DemoCompanyBrand> = {
  'boston-scientific': {
    slug: 'boston-scientific',
    name: 'Boston Scientific',
    tagline: 'Advancing Science for Life',
    loginMessage: 'Welcome to Boston Scientific Training Academy',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Boston_Scientific_Logo.svg/2560px-Boston_Scientific_Logo.svg.png',
    primaryColor: '285 60% 30%', // Purple
    primaryColorHex: '#6D2077',
    accentColor: '285 50% 40%',
    supportEmail: 'training@bostonscientific.com',
    sampleStats: {
      activeUsers: 342,
      simulationsCompleted: 1847,
      avgScore: 87,
      teamMembers: 156,
    },
    sampleSimulations: [
      { name: 'Cardiac Device Consultation', type: 'Patient Simulation', difficulty: 'Advanced', duration: '15 min' },
      { name: 'Interventional Cardiology Pitch', type: 'Sales Training', difficulty: 'Intermediate', duration: '10 min' },
      { name: 'Endoscopy Product Demo', type: 'Product Training', difficulty: 'Beginner', duration: '8 min' },
    ],
  },
  'edwards-lifesciences': {
    slug: 'edwards-lifesciences',
    name: 'Edwards Lifesciences',
    tagline: 'Innovation. Dedication. Transformation.',
    loginMessage: 'Welcome to Edwards Learning Hub',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Edwards_Lifesciences_logo.svg/2560px-Edwards_Lifesciences_logo.svg.png',
    primaryColor: '350 82% 42%', // Red
    primaryColorHex: '#C41230',
    accentColor: '350 70% 50%',
    supportEmail: 'learning@edwards.com',
    sampleStats: {
      activeUsers: 278,
      simulationsCompleted: 1523,
      avgScore: 91,
      teamMembers: 124,
    },
    sampleSimulations: [
      { name: 'TAVR Patient Education', type: 'Patient Simulation', difficulty: 'Advanced', duration: '12 min' },
      { name: 'Heart Valve Specialist Consult', type: 'Clinical Training', difficulty: 'Advanced', duration: '15 min' },
      { name: 'Critical Care Monitoring', type: 'Product Training', difficulty: 'Intermediate', duration: '10 min' },
    ],
  },
  'gsk': {
    slug: 'gsk',
    name: 'GSK',
    tagline: 'Ahead Together',
    loginMessage: 'Welcome to GSK Sales Excellence Platform',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/en/thumb/2/24/GSK_logo_2022.svg/1200px-GSK_logo_2022.svg.png',
    primaryColor: '24 89% 57%', // Orange
    primaryColorHex: '#F36633',
    accentColor: '24 80% 50%',
    supportEmail: 'training@gsk.com',
    sampleStats: {
      activeUsers: 892,
      simulationsCompleted: 4231,
      avgScore: 84,
      teamMembers: 423,
    },
    sampleSimulations: [
      { name: 'Respiratory Product Launch', type: 'Sales Training', difficulty: 'Intermediate', duration: '12 min' },
      { name: 'Vaccine Consultation', type: 'HCP Training', difficulty: 'Advanced', duration: '15 min' },
      { name: 'Pharmacy Representative Call', type: 'Sales Roleplay', difficulty: 'Beginner', duration: '8 min' },
    ],
  },
  'astrazeneca': {
    slug: 'astrazeneca',
    name: 'AstraZeneca',
    tagline: 'Pushing the boundaries of science to deliver life-changing medicines',
    loginMessage: 'Welcome to AstraZeneca Sales Excellence Academy',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/AstraZeneca.svg/2560px-AstraZeneca.svg.png',
    primaryColor: '300 67% 29%', // AstraZeneca Purple/Magenta
    primaryColorHex: '#7D1979',
    accentColor: '300 55% 38%',
    supportEmail: 'training@astrazeneca.com',
    sampleStats: {
      activeUsers: 1247,
      simulationsCompleted: 8934,
      avgScore: 86,
      teamMembers: 512,
    },
    sampleSimulations: [
      { name: 'Oncology Specialist Consultation', type: 'HCP Training', difficulty: 'Advanced', duration: '15 min' },
      { name: 'Respiratory Portfolio Discussion', type: 'Sales Training', difficulty: 'Intermediate', duration: '12 min' },
      { name: 'Cardiovascular Product Launch', type: 'Sales Roleplay', difficulty: 'Intermediate', duration: '10 min' },
      { name: 'Diabetes Care Value Proposition', type: 'Patient Simulation', difficulty: 'Beginner', duration: '8 min' },
    ],
  },
};

export function getDemoCompany(slug: string): DemoCompanyBrand | undefined {
  return demoCompanies[slug];
}

export function getAllDemoCompanies(): DemoCompanyBrand[] {
  return Object.values(demoCompanies);
}
